import React, { useContext, useEffect, useState } from 'react';
import { Redirect, useHistory, useParams } from 'react-router-dom';
import { gql, useMutation } from '@apollo/client';

import { AuthContext } from '../context/AuthContext';
import Logo from '../assets/logos/CL-Logo-Transparent-260x60.png';

import LoginForm from './Login/LoginForm';

interface IProps {
  location: any;
}

type LoginFormValues = {
  username: string;
  password: string;
  rememberMe: string;
};

interface LoginParams {
  accessToken?: string;
}

const Login: React.FC<IProps> = ({ location }) => {
  const history = useHistory();
  let { from } = location.state || { from: { pathname: '/deliveries' } };
  const { accessToken } = useParams<LoginParams>();
  const { login, isAuthenticated, getTokenMeta } = useContext(AuthContext);
  const [failedLogin, setFailedLogin] = useState<boolean>(false);

  const [authorize] = useMutation(AUTHORIZE_MUTATION, {
    onCompleted: ({ authorize: authData }) => {
      if (!login(authData)) setFailedLogin(true);
    },
    onError: (error) => {
      setFailedLogin(true);
    },
  });

  useEffect(() => {
    if (accessToken && login) {
      if (!login({ accessToken })) setFailedLogin(true);
    }
    if (getTokenMeta) {
      try {
        const meta = getTokenMeta();
        if (meta && meta.rurl) {
          history.push({
            pathname: meta.rurl,
          });
        }
      } catch (error) {}
    }
  }, [accessToken, login, getTokenMeta]);

  const onLogin = (values: LoginFormValues) => {
    authorize({ variables: { ...values } });
  };

  if (isAuthenticated) return <Redirect to={from} />;

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <img
          className="mx-auto max-h-16 md:max-h-20 w-auto"
          src={Logo}
          alt="Logo"
        />

        <h2 className="mt-4 text-center text-xl md:text-2xl font-extrabold text-gray-700">
          Sign in to your Client Portal
        </h2>
      </div>

      <LoginForm
        onLogin={onLogin}
        failedLogin={failedLogin}
        setFailedLogin={setFailedLogin}
      />
    </div>
  );
};

export default Login;

const AUTHORIZE_MUTATION = gql`
  mutation Login_AuthData($username: String!, $password: String!) {
    authorize(username: $username, password: $password) {
      accessToken
      tokenType
      expiresIn
    }
  }
`;
